import {
  CommunicationService,
  EngineIncomingNotificationMessage,
  EngineOutgoingNotificationMessage,
  getRrwebIframe,
} from '@carboncopyco/mimesis-shared';
import type { RefObject } from 'react';
import { v4 as generateUUID } from 'uuid';

interface ShowNotifyArgs {
  message: string;
  actionText?: string;
  onActionClick?: () => void;
}

const communicationService = new CommunicationService({
  ignoreDeviceContext: true,
});

export const useNotify = (rootElement: RefObject<HTMLElement>) => {
  const showNotify = ({
    onActionClick,
    message,
    actionText = 'Cancel',
  }: ShowNotifyArgs) => {
    const iframeEl = getRrwebIframe(rootElement?.current);
    const snackbarId = generateUUID();

    communicationService.postMessage({
      message: {
        type: EngineIncomingNotificationMessage.showSnackbar,
        payload: {
          message,
          actionText,
          snackbarId,
        },
      },
      targetWindow: iframeEl.contentWindow,
    });

    if (onActionClick) {
      communicationService.onMessage(function messageHandler(msg) {
        if (
          msg.data.type ===
            EngineOutgoingNotificationMessage.snackbarActionClick &&
          msg.data?.payload?.snackbarId === snackbarId
        ) {
          onActionClick();
          communicationService.removeMessageListener(messageHandler);
        }
      });
    }
  };

  const closeNotify = () => {
    const iframeEl = getRrwebIframe(rootElement?.current);
    communicationService.postMessage({
      message: {
        type: EngineIncomingNotificationMessage.dismissSnackbar,
      },
      targetWindow: iframeEl.contentWindow,
    });
  };

  return { showNotify, closeNotify };
};
